module.exports = __webpack_public_path__ + "static/img/FigmaDDSSlicePNG6c5fa10b04f2cbe7eab832c06f408dd5.6c5fa10b.png";